import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { GlobalComponent } from 'src/app/global/global.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorService } from 'src/app/error.service';
import { GeneralService } from 'src/app/service/general.service';
import {GetRetuenPayrollBo } from './payroll.model';
import { DatePipe } from '@angular/common';

@Injectable()

export class UnpaidHTTPService extends Subject<DataStateChangeEventArgs>{
  originaldata: any = [];
  childData: any = [];
  idlist: any = [];
  public details: any = [];
  errorlist: any = [];
  serialno: any;
  constructor(private http: HttpClient, private ngxService: NgxUiLoaderService,public datePipe: DatePipe, public errorService: ErrorService, public global: GlobalComponent, public general: GeneralService) {
    super();
  }
  public execute(state: GetRetuenPayrollBo): void {
    this.getUnpaidList(state).subscribe(M => super.next(M));
  }
  getUnpaidList(state?: GetRetuenPayrollBo): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Payroll/GetUnPaidPayroll", state)
      .map(
        (response: any) =>
        (<any>{
          count: response['count'],
          result: response['result']
        }
        )
      ).map((e: any) => {
        return e;
      })
  }


}




